<div class="template-crud-com-abas container-fluid">
    <div class="row">
        <div class="col-md-8">
            <h3>{{titulo}}</h3>
            <p>{{subtitulo}}</p>
        </div>
        <div class="col-md-4 text-right pt-2" *ngIf="exibeBotaoNovo">
            <button mat-flat-button color="primary" class="btn-novo"
            [disabled]="habilitarInclusao==false"
            (click)="novo()">
                <i class="fas fa-plus" style="font-size: 12px"></i>&nbsp;{{botaonovo == null ? 'Novo' : botaonovo}}
            </button>
        </div>
    </div>
    <mat-card id="filters" appearance="outlined">
        <mat-card-header class="header-padrao">
            <mat-card-title>
                <ng-template [ngComponentOutlet]="componenteFiltro.component"
                    [ndcDynamicInputs]="componenteFiltro.inputs" [ndcDynamicOutputs]="componenteFiltro.outputs">
                </ng-template>
            </mat-card-title>
        </mat-card-header>
        <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
        <mat-card-content class="no-padding">
            <div>
                <dynamic-component [hidden]="true"></dynamic-component>
                <mat-tab-group mat-stretch-tabs="false" #tabGroup mat-align-tabs="start" class="dynamic-tabs" dynamicHeight="true"
                    [class]="arrayAbas.length > 0 ? 'with-details' : ''" [selectedIndex]="tabIndex"
                    (selectedIndexChange)="tabIndex = $event">
                    <mat-tab>
                        <ng-template *ngIf="exibirGrid" [ngComponentOutlet]="componenteGrid.component"
                            [ndcDynamicInputs]="componenteGrid.inputs" [ndcDynamicOutputs]="componenteGrid.outputs">
                        </ng-template>
                        <ng-template mat-tab-label>
                            Resultados da busca &nbsp; <i class="fas fa-times" [matTooltip]="'Limpar pesquisa'"
                                (click)="clearFields()"></i>
                        </ng-template>
                    </mat-tab>
                    <mat-tab *ngFor="let tab of arrayAbas; let index = index" [label]="">
                        <ng-template [ngComponentOutlet]="tab.component" [ndcDynamicInputs]="tab.inputs"
                            [ndcDynamicOutputs]="tab.outputs">
                        </ng-template>
                        <ng-template mat-tab-label>
                            {{ tab.label }} &nbsp; <i class="fas fa-times" [matTooltip]="'Fechar aba'"
                                (click)="removerTab(index, $event)"></i>
                        </ng-template>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </mat-card-content>
    </mat-card>
</div>
